import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Trans, useTranslation } from 'react-i18next';

import AliPayWarningImg from '@/assets/alipay-warning.png';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const AliPayWarningModal = NiceModal.create(() => {
  const modal = useModal('alipay-warning-modal');
  const { t } = useTranslation();

  const handleClose = () => {
    modal.hide();
    setTimeout(() => {
      modal.remove();
    }, 100);
  };

  return (
    <Dialog open={modal.visible}>
      <DialogContent className="w-[90%] max-w-[320px]">
        <DialogHeader>
          <DialogTitle className="text-center text-base font-medium">
            <div className="leading-[1.5]">
              <Trans
                i18nKey="alipay_warning_dialog_title"
                components={{ red: <span className="text-caution font-semibold" /> }}
              />
            </div>
          </DialogTitle>
        </DialogHeader>
        <div>
          <img src={AliPayWarningImg} alt="Alipay Warning" />
        </div>
        <DialogFooter className="flex">
          <Button className="flex-1" onClick={handleClose}>
            {t('acknowledge')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

export default AliPayWarningModal;
